import { pickAssistantMessageMetaFromResult, postChatCompletion } from '@/services/chatApi'
import { applyApiBlocksOnlyResult } from './applyApiBlocksOnlyResult.js'
import { applyStreamProgressEvent } from './applyStreamProgressEvent.js'
import { reportApiCompletionFailure } from './reportApiCompletionFailure.js'
import { streamApiCompletionText } from './streamApiCompletionText.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   apiMessages: Array<{ role: string, content: string }>,
 *   files?: unknown[],
 *   mode?: string,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} ApiCompletionCtx
 */

/** @param {ApiCompletionCtx} ctx */
export function runApiCompletionStream(ctx) {
  const { apiMessages, files, mode, signal, session, tid } = ctx

  void postChatCompletion({
    messages: apiMessages,
    files,
    mode,
    signal,
    threadId: tid,
    onStreamEvent: (event) => applyStreamProgressEvent(ctx, event),
  }).then((result) => {
    if (result.ok === false && result.code === 'ABORTED') {
      session.dispose()
      return
    }

    if (!result.ok) {
      reportApiCompletionFailure(ctx, result)
      return
    }

    const fullText = result.text ?? ''
    const blocksFromApi = Array.isArray(result.blocks) && result.blocks.length ? result.blocks : null
    const assistantMeta = pickAssistantMessageMetaFromResult(result)

    if (!fullText.length && blocksFromApi) {
      applyApiBlocksOnlyResult(ctx, blocksFromApi, assistantMeta)
      return
    }

    streamApiCompletionText({ ...ctx, fullText, blocksFromApi, assistantMeta })
  })
}
